/* ============================================================
 * bundle-quantity.js
 * (anti-freeze: observer ciblé + verrou + debounce)
 * ============================================================ */

(function () {
  'use strict';

  /* ================== CONFIG ================== */

  var SHOW_UNIT_PRICE = false;
  var INCLUDE_OPTIONS_IN_COMPARE = true;

  var BUNDLE_CONTAINER_SELECTOR = '#bundle-tiers';
  var BASE_UNIT_EL_ID = 'base-unit-price';

  // IMPORTANT: mets #live-price-target en premier si c'est ton prix final
  var PRICE_SEL = '#live-price-target, .price__current, .price-item--sale, .price-item--regular, [data-product-price]';

  var EPS = 0.005; // 0.5 centime

  /* ================== ÉTAT GLOBAL ================== */

  var perUnitOptionsLpo = 0;

  var __priceObserver = null;

  // Anti-boucle: si on est en train d'écrire dans le DOM des paliers
  var __isUpdatingTiers = false;

  // Debounce (rafale d'events LPO / mutations)
  var __rafScheduled = false;

  /* ================== UTILS ================== */

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function moneyCH(n) {
    return 'CHF ' + (Math.round(n * 100) / 100).toFixed(2).replace('.', ',');
  }

  function getBaseUnit() {
    var el = document.getElementById(BASE_UNIT_EL_ID);
    if (!el) return 0;
    var cents = parseInt(el.getAttribute('data-base-unit-price-cents') || '0', 10);
    if (isNaN(cents)) cents = 0;
    return cents / 100;
  }

  function readTiers(container) {
    if (!container) return [];
    var raw = container.getAttribute('data-tiers') || '';
    var arr = [];
    try {
      var v = JSON.parse(raw);
      arr = Array.isArray(v) ? v : [];
    } catch (_) {
      arr = String(raw).split(/[,\|;\s]+/);
    }
    return arr
      .map(function (x) { return parseInt(x, 10); })
      .filter(function (n) { return n > 0; });
  }

  function readTierPrices(container) {
    try {
      var raw = container.getAttribute('data-tier-prices');
      if (!raw || raw === 'null') return {};
      var obj = JSON.parse(raw);
      if (typeof obj === 'string') {
        try { obj = JSON.parse(obj); } catch (_) { obj = {}; }
      }
      return obj && typeof obj === 'object' ? obj : {};
    } catch (_) {
      return {};
    }
  }

  function getDisplayedUnit() {
    var el = document.querySelector(PRICE_SEL);
    if (!el) return 0;
    var txt = (el.textContent || el.getAttribute('data-product-price') || '')
      .replace(',', '.')
      .replace(/[^\d.-]/g, '');
    var n = parseFloat(txt);
    return isNaN(n) ? 0 : n;
  }

  function syncPerUnitFromDomIfPossible() {
    var baseUnit = getBaseUnit();
    var displayed = getDisplayedUnit();
    if (!baseUnit || !displayed) return;

    var diff = displayed - baseUnit;
    if (Math.abs(diff) <= EPS) perUnitOptionsLpo = 0;
    else perUnitOptionsLpo = diff > 0 ? diff : 0;
  }

  function scheduleRecalc() {
    if (__rafScheduled) return;
    __rafScheduled = true;
    requestAnimationFrame(function () {
      __rafScheduled = false;

      // si on est en plein write des paliers, on évite de boucler
      if (__isUpdatingTiers) return;

      syncPerUnitFromDomIfPossible();

      var container = qs(BUNDLE_CONTAINER_SELECTOR);
      if (container) updateTotals(container);
    });
  }

  /* ================== SYNC FORMULAIRES ================== */

  function syncAllFormsQty(container) {
    var sel = qs('input[name="bundle_tier"]:checked', container);
    if (!sel) return;
    var qtyValue = sel.value;

    qsa('form[action*="/cart/add"]').forEach(function (form) {
      var q = qs('input[name="quantity"]', form);
      if (!q) {
        q = document.createElement('input');
        q.type = 'hidden';
        q.name = 'quantity';
        form.appendChild(q);
      }
      q.value = qtyValue;

      var propQty = qs('input[name="properties[BundleQty]"]', form);
      if (!propQty) {
        propQty = document.createElement('input');
        propQty.type = 'hidden';
        propQty.name = 'properties[BundleQty]';
        form.appendChild(propQty);
      }
      propQty.value = qtyValue;
    });
  }

  /* ================== CALCUL DES TOTAUX ================== */

  function updateTotals(container) {
    if (!container) container = qs(BUNDLE_CONTAINER_SELECTOR);
    if (!container) return;

    var tiers = readTiers(container);
    if (!tiers.length) return;

    var base = getBaseUnit();
    var tierMap = readTierPrices(container);

    __isUpdatingTiers = true;
    try {
      qsa('label[data-bundle-tier]', container).forEach(function (label) {
        var qty = parseInt(label.getAttribute('data-bundle-tier'), 10);
        if (!qty) return;

        var unitAtTier =
          tierMap[String(qty)] != null
            ? parseFloat(tierMap[String(qty)])
            : base;

        var total = (unitAtTier + perUnitOptionsLpo) * qty;

        var compareUnit = INCLUDE_OPTIONS_IN_COMPARE
          ? base + perUnitOptionsLpo
          : base;
        var compareTotal = compareUnit * qty;
        var strike = total < compareTotal - EPS;

        var totalSpan = qs('.tier-total', label);
        if (totalSpan) {
          var html = '';
          if (strike) html += '<s>' + moneyCH(compareTotal) + '</s> ';
          html += '<strong>' + moneyCH(total) + '</strong>';
          totalSpan.innerHTML = html;
        }

        if (SHOW_UNIT_PRICE) {
          var unitSpan = qs('.tier-unit', label);
          if (unitSpan) unitSpan.textContent = moneyCH(unitAtTier) + '/u';
        }
      });
    } finally {
      __isUpdatingTiers = false;
    }
  }

  /* ================== RENDER DES PALIERS ================== */

  function renderBundle(container) {
    if (!container) return;
    if (container.getAttribute('data-bundle-rendered') === 'true') return;

    var root =
      container.closest(
        '[data-section-type="product"], .product, .product__info-container'
      ) || document;

    var form =
      qs('form[action*="/cart/add"]', root) || qs('product-form form', root);
    if (!form) return;

    var qtyInput = qs('input[name="quantity"]', form);
    if (!qtyInput) {
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      form.appendChild(qtyInput);
    }

    var propQty = qs('input[name="properties[BundleQty]"]', form);
    if (!propQty) {
      propQty = document.createElement('input');
      propQty.type = 'hidden';
      propQty.name = 'properties[BundleQty]';
      form.appendChild(propQty);
    }

    var base = getBaseUnit();
    var tiers = readTiers(container);
    var tierMap = readTierPrices(container);
    if (!tiers.length) return;

    var html =
      '<fieldset class="bundle-tier" aria-label="Choisir une quantité"><legend>Quantité / Total</legend>';

    tiers.forEach(function (q, i) {
      var qty = parseInt(q, 10);
      var unitAtTier =
        tierMap[String(qty)] != null
          ? parseFloat(tierMap[String(qty)])
          : base;

      var total = unitAtTier * qty;
      var compareTotal = base * qty;
      var strike = total < compareTotal - EPS;

      html +=
        '<label data-bundle-tier="' + qty + '">' +
          '<input type="radio" name="bundle_tier" value="' + qty + '" ' + (i === 0 ? 'checked' : '') + '>' +
          '<span>' + qty + ' ex.</span>' +
          '<span class="tier-right">';

      if (SHOW_UNIT_PRICE) {
        html += '<span class="tier-unit">' + moneyCH(unitAtTier) + '/u</span>';
      }

      html += '<span class="tier-total">';
      if (strike) html += '<s>' + moneyCH(compareTotal) + '</s> ';
      html += '<strong>' + moneyCH(total) + '</strong>';
      html += '</span></span></label>';
    });

    html += '</fieldset>';

    container.innerHTML = html;
    container.setAttribute('data-bundle-rendered', 'true');

    syncAllFormsQty(container);
    scheduleRecalc();

    container.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'bundle_tier') {
        syncAllFormsQty(container);
        scheduleRecalc();
      }
    });

    qsa('form[action*="/cart/add"]').forEach(function (f) {
      f.addEventListener('submit', function () {
        syncAllFormsQty(container);
      });
      var atc = qs('[type="submit"], button[name="add"], .add-to-cart', f);
      if (atc) {
        atc.addEventListener('click', function () {
          syncAllFormsQty(container);
        });
      }
    });
  }

  /* ================== INTÉGRATION LPO (options:price) ================== */

  window.addEventListener('options:price', function (e) {
    try {
      var data = (e && e.detail) || {};

      var priceCents = Number(data.price);
      var optionsCents = Number(data.options);

      if (!isFinite(priceCents)) priceCents = 0;
      if (!isFinite(optionsCents)) optionsCents = 0;

      // qty Shopify actuelle (sync par nos radios)
      var mainForm = qs('form[action*="/cart/add"]');
      var qty = 1;
      if (mainForm) {
        var qInput = qs('input[name="quantity"]', mainForm);
        if (qInput) qty = parseInt(qInput.value, 10) || 1;
      }
      if (qty < 1) qty = 1;

      var baseUnit = getBaseUnit();
      var unitFromLpo = priceCents > 0 ? (priceCents / 100) / qty : baseUnit;

      if (Math.abs(unitFromLpo - baseUnit) <= EPS || optionsCents <= 0) {
        perUnitOptionsLpo = 0;
      } else {
        perUnitOptionsLpo = (optionsCents / 100) / qty;
        if (!isFinite(perUnitOptionsLpo) || perUnitOptionsLpo < 0) perUnitOptionsLpo = 0;
      }

      scheduleRecalc();
    } catch (_) {
      perUnitOptionsLpo = 0;
      scheduleRecalc();
    }
  });

  /* ================== OBSERVER SUR LE PRIX AFFICHÉ ================== */

  function initPriceObserver() {
    var priceEl = document.querySelector(PRICE_SEL);
    if (!priceEl) return;

    if (__priceObserver) {
      try { __priceObserver.disconnect(); } catch (_) {}
    }

    // IMPORTANT: observer le prix lui-même, pas le parent (sinon boucle)
    __priceObserver = new MutationObserver(function () {
      if (__isUpdatingTiers) return;
      scheduleRecalc();
    });

    __priceObserver.observe(priceEl, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  /* ================== INIT ================== */

  function initBundlesFromDom(root) {
    root = root || document;
    var container = qs(BUNDLE_CONTAINER_SELECTOR, root);
    if (container) renderBundle(container);
  }

  // Quand on change de variante, certains thèmes remplacent le bloc prix :
  // on réinitialise l'observer au prochain tick.
  function bindVariantChangeReinit() {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;

      // La plupart des thèmes changent la variante via select[name="id"]
      if (t.matches && t.matches('select[name="id"], input[name="id"]')) {
        setTimeout(function () {
          initPriceObserver();
          scheduleRecalc();
        }, 0);
      }
    }, true);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBundlesFromDom(document);
    initPriceObserver();
    bindVariantChangeReinit();
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (!e || !e.target) return;
    initBundlesFromDom(e.target);
    initPriceObserver();
  });
})();
